import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import IssuesPage from './pages/IssuesPage';
import ItemsPage from './pages/ItemsPage';
import AuthorsPage from './pages/AuthorsPage';
import AskObnPage from './pages/AskObnPage';
import LiveDashboardPage from './pages/LiveDashboardPage';
import CommandsPage from './pages/CommandsPage';
import ProfilePage from './pages/ProfilePage';
import ItemDetailPage from './pages/ItemDetailPage';
import StyleGuidePage from './pages/StyleGuidePage';
import OpinionsPage from './pages/OpinionsPage';
import SectionGuidesPage from './pages/SectionGuidesPage';
import SingleSendsPage from './pages/SingleSendsPage';
import ContactsPage from './pages/ContactsPage';
import ContactStatsPage from './pages/ContactStatsPage';
import EventsPage from './pages/EventsPage';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  return (
    <Routes>
      <Route path="/login" element={!isAuthenticated ? <LoginPage /> : <Navigate to="/dashboard" />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<Layout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/issues" element={<IssuesPage />} />
          <Route path="/issues/:issueNumber" element={<IssuesPage />} />
          <Route path="/items" element={<ItemsPage />} />
          <Route path="/items/:itemId" element={<ItemDetailPage />} />
          <Route path="/authors" element={<AuthorsPage />} />
          <Route path="/authors/:authorId" element={<AuthorsPage />} />
          <Route path="/ask-obn" element={<AskObnPage />} />
          <Route path="/commands" element={<CommandsPage />} />
          <Route path="/style-guide" element={<StyleGuidePage />} />
          <Route path="/opinions" element={<OpinionsPage />} />
          <Route path="/section-guides" element={<SectionGuidesPage />} />
          <Route path="/email/single-sends" element={<SingleSendsPage />} />
          <Route path="/email/contacts" element={<ContactsPage />} />
          <Route path="/email/contact-stats" element={<ContactStatsPage />} />
          <Route path="/email/events" element={<EventsPage />} />
          <Route path="/profile" element={<ProfilePage />} />
        </Route>
        {/* Live Dashboard - Outside Layout for full screen experience */}
        <Route path="/live-dashboard" element={<LiveDashboardPage />} />
      </Route>
      
      <Route path="/" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
}

export default App;